import {
  Component,
  Input,
  HostBinding,
  ElementRef,
  ViewChild
} from '@angular/core';
import { MenuIconTypes } from './../main-icon/main-icon.component';
import chroma from 'chroma-js';

@Component({
  selector: 'bepatient-dynamic-menu-main-button',
  templateUrl: './main-button.component.html',
  styleUrls: ['./main-button.component.scss'],
  standalone: false
})
export class MainButtonComponent {
  @Input() icon: MenuIconTypes;
  @Input() label: string;
  @Input() color: string;
  @Input() iconColor: string;
  @Input() notifications: number;

  @HostBinding('class.reversed') @Input() reversed: boolean;
  @ViewChild('labelRef', { read: ElementRef, static: true })
  labelElementRef: ElementRef;

  @Input() set selected(v: boolean) {
    this.labelElementRef.nativeElement.style.setProperty(
      'color',
      v ? chroma(this.color).brighten() : 'var(--ion-text-color)'
    );
  }
}
